// extracted by mini-css-extract-plugin
module.exports = {"office":"styles_office__3SkS5"};